import QuizBody from './QuizBody';

export default QuizBody;
